module.exports = __webpack_public_path__ + "media/seq5.92007c3f.mp4";